<template>
  <div class="main_div">
    <section id="container" class="cmdp_main" style="padding-top:120px">
      <div>
        <div style="width: 30%; float: right; text-align: right; font-size: 22px; line-height: 44px;">
          <button class="large_btn orange" style="width: 100px; float: right; margin-left: 20px;"
            @click="commonOnChangeEvent">새로고침</button> {{ lastRenderingTime }}
        </div>
        <kendo-multiselect class="w15" ref="facilityRef" id="cdNm" :tag-mode="'single'" :data-source="zone1DepthList"
          :data-value-field="'cdId'" :data-text-field="'cdNm'" :auto-close="false" @change="onChangeFacility"
          :tag-template="`<span class='k-input'>#:values.length# 사업장 선택됨 </span>`">
        </kendo-multiselect>
        <kendo-multiselect class="w10 mgl10" ref="areaRef" id="cdNm" :tag-mode="'single'" :data-source="zone2DepthList"
          :data-value-field="'cdId'" :data-text-field="'cdNm'" :auto-close="false" @change="onChangeArea"
          :tag-template="`<span class='k-input'>#:values.length# 거점 선택됨 </span>`">
        </kendo-multiselect>
        <button class="mid_btn orange mgl10" @click="commonOnChangeEvent">검색</button>
        <ul class="list_company">
          <li v-for="item in areaList.nmList">{{ item.cdNm }}<span class="k-icon k-i-close"
              @click="onClickDeleteArea(item)"></span></li>
        </ul>
      </div>
      <div class="box_flex mgt20 left">
        <div class="ai_box_bg w35" style="padding:20px">
          <span class="mgt10 f_r">◾ 당일 기준</span>
          <h1 class="mgt5">키오스크 사용 현황</h1>
          <div class="box_flex mgt20">
            <div class="w25 txt_l">
              <h3 class="mg0">키오스크 / 보관함</h3>
              <div class="kiosk_num" style="margin-top:-10px">
                {{ kioskInfo.kioskCnt + kioskInfo.unUsedKioskCnt }}/{{ kioskInfo.lockerCnt + kioskInfo.unUsedLockerCnt
                }}
              </div>
              <dl class="box_t_l mg0">
                <dd><b>{{ !!kioskInfo.kioskCnt ? kioskInfo.kioskCnt : '0' }}</b>
                </dd>
                <dt>키오스크</dt>
                <dd><b>{{ !!kioskInfo.lockerCnt ? kioskInfo.lockerCnt : '0' }}</b>
                </dd>
                <dt>무인보관함</dt>
                <dd><b>{{ !!kioskInfo.unUsedKioskCnt ? kioskInfo.unUsedKioskCnt : '0' }} / {{
                    !!kioskInfo.unUsedLockerCnt ? kioskInfo.unUsedLockerCnt : '0' }}</b>
                </dd>
                <dt>미사용</dt>
              </dl>
            </div>
            <div class="w70 mgl20">
              <ul class="box_flex box_t_r mgt10">
                <li>
                  <div class="txt01">
                    긴급공지
                  </div>
                  <div class="txt02">
                    {{ !!kioskInfo.onEmergencyCnt ? kioskInfo.onEmergencyCnt : '0' }}
                  </div>
                </li>
                <li>
                  <div class="txt01">
                    운송장 번호잔량
                  </div>
                  <div class="txt02">
                    {{ !!kioskInfo.availableBlNoCnt ? kioskInfo.availableBlNoCnt : '0' }}
                  </div>
                </li>
                <li>
                  <div class="txt01">
                    업데이트 필요
                  </div>
                  <div class="txt02">
                    {{ !!kioskInfo.outdatedCnt ? kioskInfo.outdatedCnt : '0' }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="box_l_b">
            <div class="f_r w60">
              <kendo-dropdownlist class="w100" ref="kioskRef" :data-source="kioskDataSource"
                :data-text-field="'kioskNm'" :data-value-field="'kioskNo'" @change="onChangeKioskInfo">
              </kendo-dropdownlist>
            </div>
            <h2>키오스크별 상태</h2>
            <ul class="box_traffic mgt30">
              <li>
                <div :class="leftOverCellCntImg" :style="{ background : `url(${leftOverCellCntImg})`}"></div>
                <div class="txt01">잔여보관함</div>
                <div v-if="kioskInfo.storageType === '02'" class="txt02">미사용</div>
                <div v-else :class="{txt02: 'txt02', red: kioskInfo.leftoverCellCnt < 5}">{{ !!kioskInfo.leftoverCellCnt ? kioskInfo.leftoverCellCnt : '0' }}<span class="f_s">건</span></div>
              </li>
              <li>
                <div :class="regiLabelCntImg" :style="{ background : `url(${regiLabelCntImg})`}"></div>
                <div class="txt01">라벨 잔여 수량</div>
                <div :class="{txt02: 'txt02', red: kioskInfo.regiLabelCnt < 30}">{{ !!kioskInfo.regiLabelCnt ?
                  kioskInfo.regiLabelCnt : '0' }}<span class="f_s">건</span></div>
              </li>
              <li>
                <div :class="deliveryLabelCntImg" :style="{ background : `url(${deliveryLabelCntImg})`}"></div>
                <div class="txt01">운송장 라벨 잔여 수량</div>
                <div :class="{txt02: 'txt02', red: kioskInfo.deliveryLabelCnt < 30}">{{ !!kioskInfo.deliveryLabelCnt ?
                  kioskInfo.deliveryLabelCnt : '0' }}<span class="f_s">건</span></div>
              </li>
            </ul>
            <h2 class="mgt40">시간별 키오스크 접수 분포도<span class="txt_s">[일간 | 주간]</span></h2>
            <div class="box_graph mg0 mgt10">
              <chart ref="chart" style="height:215px;" :render-as="'canvas'" :chart-area-background="''" :legend="{
                       position: 'bottom',
                       visible: true
                     }" :series-defaults="{
                       type: 'area',
                       area: {line: {style: 'smooth'}},
                       markers:{
                          visible: false,
                          size: 5,
                        }
                     }" :valueAxis="{
                        labels: {format: '{0}'},
                        line: {visible: false},
                        axisCrossing: {value: '-10'}
                     }" :categoryAxis="{
                       majorGridLines: {visible: false},
                       labels: {rotation: 'auto', format: '{0}', step: 1},
                       categories: [1,2,3,4,5,6,7,8,9,10,11,12,13]
                     }" :tooltip="dailyToolTip" :series="[
                        {field: 'today', categoryField: 'hour', name: '오늘'},
                        {field: 'avg', categoryField: 'hour', name: '주간통계'}
                     ]" :data-source="kioskReceipt" :theme="'fiori'">
              </chart>
            </div>
          </div>
        </div>
        <div class="w60 f_r box_flex_row mg0">
          <div class="contents_wrap pd0">
            <div class="kiosk_m_title">
              금일 수/발신 현황
              <span class="mgl10" style="font-size:13px; font-weight:400">* 파우치는 <u>현재 키오스크 설치 거점 기준 수신 건 카운트</u> 됩니다.
              </span>
            </div>
            <div style="border-bottom:1px solid #efefef">
              <div class="kiosk_box specification_ver2">
                <ul class="list_box_ver2 mgt10">
                  <li style="border:none">
                    <div class="general_label">
                      수신
                    </div>
                    <div class="label">전일대비
                      <span class="ml5" :class="{'fblue': getReceiveDiffRate<0, 'fred':getReceiveDiffRate>0}">
                        {{ getReceiveDiffRate!==0 ? Math.abs(getReceiveDiffRate) : '-' }}
                        <span v-if="getReceiveDiffRate > 0" class="k-icon k-i-arrow-up fred"></span>
                        <span v-else-if="getReceiveDiffRate < 0" class="k-icon k-i-arrow-down fblue"></span>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      전체
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.receiveReceiptCnt ? todayReceiptInfo.receiveReceiptCnt.totalCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      등기
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.receiveReceiptCnt ? todayReceiptInfo.receiveReceiptCnt.regiCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      택배
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.receiveReceiptCnt ? todayReceiptInfo.receiveReceiptCnt.deliCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      특송
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.receiveReceiptCnt ? todayReceiptInfo.receiveReceiptCnt.exprCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      파우치
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.receiveReceiptCnt ? todayReceiptInfo.receiveReceiptCnt.pouchCnt : '0' }}
                    </div>
                  </li>
                  <li class="box_flex w20">
                    <div class="txt_c mgt10">
                      <chart class="mgl10" style="height:120px; margin: 0 auto; width:300px;" :theme="'fiori'"
                        ref="todayReceiveChartRef" :legend="{
                               position: 'top',
                               visible: true
                             }" :tooltip="{
                                visible: true,
                                template: '#= series.name #: #= value #%'
                             }" :series-defaults="{
                               stack: {type: '100%'},
                               type: 'bar'
                             }" :data-source="todayReceiveDataSource" :series="[{
                                field: 'regiCnt',
                                name: '등기',
                                categoryField: 'totalCnt',
                                color: '#f0928c'
                              },{
                                field: 'deliCnt',
                                name: '택배',
                                categoryField: 'totalCnt',
                                color: '#e84ea9'
                              },{
                                field: 'exprCnt',
                                name: '해외특송',
                                categoryField: 'totalCnt',
                                color: '#4c40f6'
                              },{
                                field: 'pouchCnt',
                                name: '파우치',
                                categoryField: 'totalCnt',
                                color: '#4eaf57'
                              }]" :value-axis="[{
                                  line: {visible: false},
                                  minorGridLines: {visible: false}
                             }]" :category-axis="{
                                  visible: false,
                                  majorGridLines: {visible: false}
                              }"></chart>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="pd0">
              <div class="kiosk_box specification_ver2">
                <ul class="list_box_ver2 mgt10">
                  <li style="border:none">
                    <div class="emergency_label">
                      발신
                    </div>
                    <div class="label">전일대비
                      <span class="ml5" :class="{'fblue': getSendDiffRate<0, 'fred':getSendDiffRate>0}">
                        {{ getSendDiffRate !== 0 ? Math.abs(getSendDiffRate) : '-'}}
                        <span v-if="getSendDiffRate > 0" class="k-icon k-i-arrow-up fred"></span>
                        <span v-else-if="getSendDiffRate < 0" class="k-icon k-i-arrow-down fblue"></span>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      전체
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.sendReceiptCnt ? todayReceiptInfo.sendReceiptCnt.totalCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      등기
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.sendReceiptCnt ? todayReceiptInfo.sendReceiptCnt.regiCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      택배
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.sendReceiptCnt ? todayReceiptInfo.sendReceiptCnt.deliCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      특송
                    </div>
                    <div class="s_text_ver2">
                      {{ !!todayReceiptInfo.sendReceiptCnt ? todayReceiptInfo.sendReceiptCnt.exprCnt : '0' }}
                    </div>
                  </li>
                  <li>
                    <div class="s_title_ver2">
                      파우치
                    </div>
                    <div class="s_text_ver2">
                      <!--
                      {{ !!todayReceiptInfo.sendReceiptCnt ? todayReceiptInfo.sendReceiptCnt.pouchCnt : '0' }}
                      -->
                      -
                    </div>
                  </li>
                  <li class="box_flex w20">
                    <div class="txt_c mgt10">
                      <chart class="mgl10" style="height:120px; margin: 0 auto; width:300px;" :theme="'fiori'"
                        ref="todaySendChartRef" :legend="{
                               position: 'top',
                               visible: true
                             }" :tooltip="{
                                visible: true,
                                template: '#= series.name #: #= value #%'
                             }" :series-defaults="{
                               stack: {type: '100%'},
                               type: 'bar'
                             }" :data-source="todaySendDataSource" :series="[{
                                field: 'regiCnt',
                                name: '등기',
                                categoryField: 'totalCnt',
                                color: '#f0928c'
                              },{
                                field: 'deliCnt',
                                name: '택배',
                                categoryField: 'totalCnt',
                                color: '#e84ea9'
                              },{
                                field: 'exprCnt',
                                name: '해외특송',
                                categoryField: 'totalCnt',
                                color: '#4c40f6'
                              },{
                                field: 'pouchCnt',
                                name: '파우치',
                                categoryField: 'totalCnt',
                                color: '#4eaf57'
                              }]" :value-axis="[{
                                  line: {visible: false},
                                  minorGridLines: {visible: false}
                             }]" :category-axis="{
                                  visible: false,
                                  majorGridLines: {visible: false}
                              }"></chart>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="contents_wrap pd0">
            <div class="kiosk_box specification_ver2 pd0">
              <div class="w95 mgt10" style="margin:0 auto">
                <ul class="list_box_ver2 box_flex pd0">
                  <li class="w40" style="border:none">
                    <div class="s_title_ver2 txt_l txt_g">
                      전체 누적 수신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ totalReceiveReceiptCnt }}
                      <span style="font-size: 13px; color:#777">{{ !!totalReceiptInfo.receiveReceiptCnt ? totalReceiptInfo.receiveReceiptCnt.startDt : '-' }} ~ {{ !!totalReceiptInfo.receiveReceiptCnt ? totalReceiptInfo.receiveReceiptCnt.endDt : '-' }}</span>
                    </div>
                  </li>
                  <chart class="mgl10" style="height:120px; margin: 0 auto; width:300px;" :theme="'fiori'"
                    ref="totalReceiveChartRef" :legend="{
                               position: 'right',
                               visible: true
                             }" :tooltip="{
                                visible: true,
                                template: '#= series.name #: #= value #건'
                             }" :series-defaults="{
                               type: 'column'
                             }" :data-source="totalReceiveDataSource" :series="[{
                                field: 'regiCnt',
                                name: '등기',
                                categoryField: 'totalCnt',
                                color: '#f0928c'
                              },{
                                field: 'deliCnt',
                                name: '택배',
                                categoryField: 'totalCnt',
                                color: '#e84ea9'
                              },{
                                field: 'exprCnt',
                                name: '해외특송',
                                categoryField: 'totalCnt',
                                color: '#4c40f6'
                              },{
                                field: 'pouchCnt',
                                name: '파우치',
                                categoryField: 'totalCnt',
                                color: '#4eaf57'
                              }]" :value-axis="[{
                                  line: {visible: false},
                                  majorUnit: 1000,
                                  minorGridLines: {visible: false}
                             }]" :category-axis="{
                                  visible: false,
                                  majorGridLines: {visible: false}
                              }"></chart>
                  <li class="w40 mgl20">
                    <div class="s_title_ver2 txt_l txt_o">
                      전체 누적 발신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ totalSendReceiptCnt }}
                      <span style="font-size: 13px; color:#777">{{ !!totalReceiptInfo.sendReceiptCnt ? totalReceiptInfo.sendReceiptCnt.startDt : '-' }} ~ {{ !!totalReceiptInfo.sendReceiptCnt ? totalReceiptInfo.sendReceiptCnt.endDt : '-' }}</span>
                    </div>
                  </li>
                  <chart class="mgl10" style="height:120px; margin: 0 auto; width:300px;" :theme="'fiori'"
                    ref="totalSendChartRef" :legend="{
                               position: 'right',
                               visible: true
                             }" :tooltip="{
                                visible: true,
                                template: '#= series.name #: #= value #건'
                             }" :series-defaults="{
                               type: 'column'
                             }" :data-source="totalSendDataSource" :series="[{
                                field: 'regiCnt',
                                name: '등기',
                                categoryField: 'totalCnt',
                                color: '#f0928c'
                              },{
                                field: 'deliCnt',
                                name: '택배',
                                categoryField: 'totalCnt',
                                color: '#e84ea9'
                              },{
                                field: 'exprCnt',
                                name: '해외특송',
                                categoryField: 'totalCnt',
                                color: '#4c40f6'
                              },{
                                field: 'pouchCnt',
                                name: '파우치',
                                categoryField: 'totalCnt',
                                color: '#4eaf57'
                              }]" :value-axis="[{
                                  line: {visible: false},
                                  majorUnit: 500,
                                  minorGridLines: {visible: false}
                             }]" :category-axis="{
                                  visible: false,
                                  majorGridLines: {visible: false}
                              }"></chart>
                </ul>
              </div>
            </div>
          </div>
          <div class="contents_wrap pd0">
            <div class="kiosk_m_title">
              당일 미완료 수량
            </div>
            <div class="box_flex" style="padding:1%">
              <div class="box_bg w25">
                <h3 class="s_title_ver">
                  등기
                </h3>
                <ul class="list_box_ver2 box_flex pd0">
                  <li class="w30">
                    <div class="s_title_ver2 txt_l txt_g">
                      수신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.receiveReceiptCnt ? incompleteReceiptInfo.receiveReceiptCnt.regiCnt :
                      '0' }}
                    </div>
                  </li>
                  <li class="w30" style="border:none">
                    <div class="s_title_ver2 txt_l txt_o">
                      발신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.sendReceiptCnt ? incompleteReceiptInfo.sendReceiptCnt.regiCnt : '0' }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="box_bg w25">
                <h3 class="s_title_ver">
                  택배
                </h3>
                <ul class="list_box_ver2 box_flex pd0">
                  <li class="w30">
                    <div class="s_title_ver2 txt_l txt_g">
                      수신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.receiveReceiptCnt ? incompleteReceiptInfo.receiveReceiptCnt.deliCnt :
                      '0' }}
                    </div>
                  </li>
                  <li class="w30" style="border:none">
                    <div class="s_title_ver2 txt_l txt_o">
                      발신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.sendReceiptCnt ? incompleteReceiptInfo.sendReceiptCnt.deliCnt : '0' }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="box_bg w25">
                <h3 class="s_title_ver">
                  해외특송
                </h3>
                <ul class="list_box_ver2 box_flex pd0">
                  <li class="w30">
                    <div class="s_title_ver2 txt_l txt_g">
                      수신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.receiveReceiptCnt ? incompleteReceiptInfo.receiveReceiptCnt.exprCnt :
                      '0' }}
                    </div>
                  </li>
                  <li class="w30" style="border:none">
                    <div class="s_title_ver2 txt_l txt_o">
                      발신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.sendReceiptCnt ? incompleteReceiptInfo.sendReceiptCnt.exprCnt : '0' }}
                    </div>
                  </li>

                </ul>

              </div>
              <div class="box_bg w25">
                <h3 class="s_title_ver">
                  파우치
                </h3>
                <ul class="list_box_ver2 box_flex pd0">
                  <li class="w30">
                    <div class="s_title_ver2 txt_l txt_g">
                      수신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      {{ !!incompleteReceiptInfo.receiveReceiptCnt ? incompleteReceiptInfo.receiveReceiptCnt.pouchCnt :
                      '0' }}
                    </div>
                  </li>
                  <li class="w30" style="border:none">
                    <div class="s_title_ver2 txt_l txt_o">
                      발신
                    </div>
                    <div class="s_text_ver2 txt_l">
                      <!--
                      {{ !!incompleteReceiptInfo.sendReceiptCnt ? incompleteReceiptInfo.sendReceiptCnt.pouchCnt : '0' }}
                      -->
                      -
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {ZoneMixin} from "@/mixin/Mixin";
import EtnersParseUtil from "@/common/etners.parse.util";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import { Chart } from '@progress/kendo-charts-vue-wrapper';
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "LogisticsDashBoard",
  mixins: [ZoneMixin],
  components: {
    'chart': Chart,
  },
  mounted() {
    const vm = this
    const zoneNmList = this.$store.state.codeRequestStore.search.combobox.zoneNmList.data
    // 전체 사업장 세팅
    // 로그인 직후 대시보드 진입 시 사업장/거점 리스트업 안되는 이슈로 추가된 코드
    if (zoneNmList.length < 1) {
      vm.getFacilityNmList()
      vm.commonOnChangeEvent()
    } else {
      vm.$refs.facilityRef.kendoWidget().value(vm.zone1DepthList)
      vm.onChangeFacility()
      vm.getKioskList()
      vm.commonOnChangeEvent()
    }
  },
  computed: {
    leftOverCellCntImg () {
      const vm = this
      if (vm.kioskInfo.storageType === '02') return vm.iconGreen
      else if (vm.kioskInfo.leftoverCellCnt < 5) return vm.iconRed
      else if (vm.kioskInfo.leftoverCellCnt >= 5 && vm.kioskInfo.leftoverCellCnt < 15) return vm.iconYellow
      else return vm.iconGreen
    },
    regiLabelCntImg () {
      const vm = this
      if (vm.kioskInfo.regiLabelCnt < 30) return vm.iconRed
      else if (vm.kioskInfo.regiLabelCnt >= 30 && vm.kioskInfo.regiLabelCnt < 100) return vm.iconYellow
      else return vm.iconGreen
    },
    deliveryLabelCntImg () {
      const vm = this
      if (vm.kioskInfo.deliveryLabelCnt < 30) return vm.iconRed
      else if (vm.kioskInfo.deliveryLabelCnt >= 30 && vm.kioskInfo.deliveryLabelCnt < 100) return vm.iconYellow
      else return vm.iconGreen
    },
    todayReceiveDataSource () {
      const vm = this
      if (!!!vm.todayReceiptInfo || !!!vm.todayReceiptInfo.receiveReceiptCnt) {
        return {data: [{}]}
      }
      let retObj = {}
      let receiveReceiptCnt = vm.todayReceiptInfo.receiveReceiptCnt
      retObj.totalCnt = receiveReceiptCnt.totalCnt
      retObj.regiCnt = Math.round((receiveReceiptCnt.regiCnt/receiveReceiptCnt.totalCnt*100) *10)/10
      retObj.deliCnt = Math.round((receiveReceiptCnt.deliCnt/receiveReceiptCnt.totalCnt*100) *10)/10
      retObj.exprCnt = Math.round((receiveReceiptCnt.exprCnt/receiveReceiptCnt.totalCnt*100) *10)/10
      retObj.pouchCnt = Math.round((receiveReceiptCnt.pouchCnt/receiveReceiptCnt.totalCnt*100) *10)/10
      return {data: [retObj]}
    },
    todaySendDataSource () {
      const vm = this
      if (!!!vm.todayReceiptInfo || !!!vm.todayReceiptInfo.sendReceiptCnt) {
        return {data: [{}]}
      }
      let retObj = {}
      let sendReceiptCnt = vm.todayReceiptInfo.sendReceiptCnt
      retObj.totalCnt = sendReceiptCnt.totalCnt
      retObj.regiCnt = Math.round((sendReceiptCnt.regiCnt/sendReceiptCnt.totalCnt*100) *10)/10
      retObj.deliCnt = Math.round((sendReceiptCnt.deliCnt/sendReceiptCnt.totalCnt*100) *10)/10
      retObj.exprCnt = Math.round((sendReceiptCnt.exprCnt/sendReceiptCnt.totalCnt*100) *10)/10
      retObj.pouchCnt = Math.round((sendReceiptCnt.pouchCnt/sendReceiptCnt.totalCnt*100) *10)/10
      return {data: [retObj]}
    },
    getReceiveDiffRate() {
      const vm = this
      if (!!!vm.todayReceiptInfo || !!!vm.todayReceiptInfo.receiveReceiptCnt) {
        return '-'
      }
      return vm.todayReceiptInfo.receiveReceiptCnt.totalCnt - vm.todayReceiptInfo.receiveReceiptCnt.yesterdayCnt
    },
    getSendDiffRate() {
      const vm = this
      if (!!!vm.todayReceiptInfo || !!!vm.todayReceiptInfo.sendReceiptCnt) {
        return '-'
      }
      return vm.todayReceiptInfo.sendReceiptCnt.totalCnt - vm.todayReceiptInfo.sendReceiptCnt.yesterdayCnt
    },
    totalReceiveDataSource () {
      const vm = this
      if (!!!vm.totalReceiptInfo || !!!vm.totalReceiptInfo.receiveReceiptCnt) {
        return {data: [{}]}
      }
      let receiveReceiptCnt = vm.totalReceiptInfo.receiveReceiptCnt
      return {data: [receiveReceiptCnt]}
    },
    totalSendDataSource () {
      const vm = this
      if (!!!vm.totalReceiptInfo || !!!vm.totalReceiptInfo.sendReceiptCnt) {
        return {data: [{}]}
      }
      let sendReceiptCnt = vm.totalReceiptInfo.sendReceiptCnt
      return {data: [sendReceiptCnt]}
    },
    totalReceiveReceiptCnt () {
      const vm = this
      return !!vm.totalReceiptInfo.receiveReceiptCnt ? vm.totalReceiptInfo.receiveReceiptCnt.totalCnt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'
    },
    totalSendReceiptCnt () {
      const vm = this
      return !!vm.totalReceiptInfo.sendReceiptCnt ? vm.totalReceiptInfo.sendReceiptCnt.totalCnt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'
    }
  },
  methods: {
    getFacilityNmList () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        sendRecvUseYn: 'Y'
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/zone/zoneCdList.json`
      ApiUtil.post(url, param,{isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        // zone1DepthList, zone2DepthList, zone2DepthMap 만 있으면, 대시보드에서는 mixin 필요 없다.
        vm.zone1DepthList = response.data.resultData.zone1DepthList
        vm.zone2DepthList = response.data.resultData.zone2DepthList
        vm.zone2DepthMap = new Map()
        for(let item of vm.zone2DepthList) {
          let zone2DeptList = vm.zone2DepthMap.get(item.cdId.substr(0,2))
          if (zone2DeptList === undefined) {
            zone2DeptList = []
          }
          zone2DeptList.push(item)
          vm.zone2DepthMap.set(item.cdId.substring(0,2), zone2DeptList)
        }
        vm.$refs.facilityRef.kendoWidget().setDataSource(vm.zone1DepthList)
        vm.$refs.facilityRef.kendoWidget().value(vm.zone1DepthList)
        vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
        vm.$refs.areaRef.kendoWidget().value(vm.zone2DepthList)

        vm.onChangeFacility()
        vm.getKioskList()
        vm.commonOnChangeEvent()
      })
    },
    onChangeFacility () {
      const vm = this
      if (!!vm.$refs.facilityRef) {

        vm.facilityList = {
          idList: vm.$refs.facilityRef.kendoWidget().value(),
          nmList: vm.$refs.facilityRef.kendoWidget().dataItems()
        }

        // zone2Depth 초기화
        let zone2DepthList = []
        vm.facilityList.idList.forEach(item => {
          zone2DepthList = [
            ...zone2DepthList,
            ...(!!vm.zone2DepthMap.get(item) ? vm.zone2DepthMap.get(item) : [])
          ]
        })

        vm.$refs.areaRef.kendoWidget().setDataSource(zone2DepthList)
        vm.$refs.areaRef.kendoWidget().value(zone2DepthList)
        vm.onChangeArea()
      }
    },
    onChangeArea () {
      const vm = this
      if (!!vm.$refs.areaRef) {
        vm.areaList = {
          idList: vm.$refs.areaRef.kendoWidget().value(),
          nmList: vm.$refs.areaRef.kendoWidget().dataItems()
        }
      }
    },

    onClickDeleteArea (item) {
      const vm = this
      let nmList = vm.areaList.nmList.filter(info => {
        if(info.cdId !== item.cdId) {
          return info
        }
      })
      let idList = vm.areaList.idList.filter(info => {
        if(info !== item.cdId) {
          return info
        }
      })

      vm.areaList = {
        idList: idList,
        nmList: nmList
      }

      // 검색에 반영
      vm.$refs.areaRef.kendoWidget().value(idList)

      vm.commonOnChangeEvent()
    },
    getKioskList () {
      const vm = this
      const facilityList = vm.$refs.facilityRef.kendoWidget().value()
      const areaList = vm.$refs.areaRef.kendoWidget().value()

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskNmList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        facilityList: facilityList,
        areaList: areaList
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.kioskDataSource = response.data.resultData
        vm.$refs.kioskRef.kendoWidget().setDataSource(vm.kioskDataSource)
        if (vm.kioskDataSource.length > 0) {
          vm.$refs.kioskRef.kendoWidget().value(vm.kioskDataSource[0].kioskNo)
        }
        vm.onChangeKioskInfo()
      })
    },
    commonOnChangeEvent() {
      const vm = this
      vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
      vm.getTodayReceipt()
      vm.getTotalReceipt()
      vm.getIncompleteReceipt()
    },
    onChangeKioskInfo () {
      const vm = this
      vm.getKioskInfoData()
      vm.getKioskReceipt()
    },

    getKioskInfoData () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        facilityList: vm.facilityList.idList,
        areaList: vm.areaList.idList,
        kioskNo: vm.$refs.kioskRef.kendoWidget().value(),
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/etcInfo.json`
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        vm.kioskInfo = response.data.resultData
      })
    },
    getKioskReceipt () {
      const vm = this
      const kioskReceipt = new kendo.data.DataSource({
        name: 'kioskReceiptCntChartDataSource',
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/kioskReceiptCnt.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function(options, operation) {
            if (operation === 'read') {
              const readParam = {
                loginUserToken: vm.loginUserToken,
                facilityList: vm.facilityList.idList,
                areaList: vm.areaList.idList,
                kioskNo: vm.$refs.kioskRef.kendoWidget().value(),
              }
              return kendo.stringify(readParam)
            }
          }
        },
        sort: {
          field: "hour",
          dir: "asc"
        },
        schema: {
          type: 'json',
          parse: function(response) {
            return response
          },
          data: function(response) {
            // 카테고리 indexNo 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function(e) {
          // console.log('error event handler', e.errors)
        }
      })
      vm.kioskReceipt = kioskReceipt
    },

    getTodayReceipt () {
      const vm = this
      const facilityList = vm.$refs.facilityRef.kendoWidget().value()
      const areaList = vm.$refs.areaRef.kendoWidget().value()

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/todayReceipt.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        facilityList: facilityList,
        areaList: areaList
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.todayReceiptInfo = response.data.resultData
      })
    },
    getTotalReceipt () {
      const vm = this
      const facilityList = vm.$refs.facilityRef.kendoWidget().value()
      const areaList = vm.$refs.areaRef.kendoWidget().value()

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/totalReceipt.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        facilityList: facilityList,
        areaList: areaList
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.totalReceiptInfo = response.data.resultData
      })
    },
    getIncompleteReceipt () {
      const vm = this
      const facilityList = vm.$refs.facilityRef.kendoWidget().value()
      const areaList = vm.$refs.areaRef.kendoWidget().value()

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/dashboard/incompleteReceipt.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        facilityList: facilityList,
        areaList: areaList
      }
      ApiUtil.post(url, params, {isShowLoadingBar:false}).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.incompleteReceiptInfo = response.data.resultData
      })
    }
  },
  data: function () {
    const now = new Date()
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),

      kioskDataSource: [],

      // 검색 조건
      facilityList: [],
      areaList: [],
      kioskNo: null,

      // 키오스크 사용 현황
      kioskInfo: {
        regiLabelCnt: 0,
        deliveryLabelCnt: 0,
        availableBlNoCnt: 0,
        lockerCnt: 0,
        unUsedLockerCnt: 0,
        leftoverCellCnt: 0,
        kioskCnt: 0,
        unUsedKioskCnt: 0,
        outdatedCnt: 0,
        onEmergencyCnt: 0
      },
      kioskReceipt: [],
      dailyToolTip: {
        visible: true,
        template: '#= series.name # : #= value # 건'
      },

      // 금일 수/발신 현황
      todayReceiptInfo: {},
      totalReceiptInfo: {},
      incompleteReceiptInfo: {},

      // css
      iconYellow: require(`@/assets/img/etners-main/icon_yellow.png`),
      iconRed: require(`@/assets/img/etners-main/icon_red.png`),
      iconGreen: require(`@/assets/img/etners-main/icon_green.png`),
    }
  }
}


</script>
<style scoped>

.box_bg.w25{;
  padding:1%
}
.box_bg.w25 .s_title_ver{
  margin:4% 0;
}

.list_box_ver2 {
  overflow: hidden;
  display:flex;
  padding: 0 20px;
}

.list_box_ver2 li {
  border-right: 1px solid #efefef;
  min-width: 12%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}



.specification_ver2 {
  padding-bottom: 10px;
}

.specification_ver2 .w4_ver2 li {
  width: 25%;
}

.s_title_ver2 {
  font-size: 16px;
  text-align: center;
  color: #999;
  font-weight: bold;
}

.s_text_ver2 {
  text-align: center;
  margin-top: 10px;
  font-size: 28px;
  font-weight: bold;
}

.s_text_ver2 .org {
  color: #fe5f40;
}

.s_text_ver2 .gray {
  color: #999999;
}


.txt_c span {
  color: #fe5f40;
  font-weight: bold;
}

.general_label {
  width: 100px;
  height: 45px;
  border-radius: 23px;
  background-color: #19ba68;
  text-align: center;
  line-height: 45px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  margin:0 auto
}

.emergency_label {
  width: 100px;
  height: 45px;
  border-radius: 23px;
  background-color: #fe5f40;
  text-align: center;
  line-height: 45px;
  color: #fff6b9;
  font-weight: bold;
  font-size: 16px;
  margin: 0 auto
}



.kiosk_m_title {
  font-size: 22px;
  border-bottom: 1px solid #efefef;
  font-weight: bold;
  height: 49px;
  line-height: 49px;
  padding-left: 30px;
}

.list_box_ver2 .label {
  background: #e9e9f3;
  padding: 2px 0;
  border-radius: 17px;
  margin: 5px 0;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  text-align: center;
}
</style>
